const VEHICLE_MIN_RENTAL_ALLOWED_HOURS = [48, 72] as const

export type VehicleMinRentalHours = (typeof VEHICLE_MIN_RENTAL_ALLOWED_HOURS)[number] | null

/** `null` means "no minimum"; anything outside the allowed list collapses to it. */
export function normalizeVehicleMinRentalHours(value: unknown): VehicleMinRentalHours {
  const numeric = typeof value === 'string' ? Number(value) : value
  return VEHICLE_MIN_RENTAL_ALLOWED_HOURS.find((hours) => hours === numeric) ?? null
}

export function vehicleMinRentalDayCount(value: unknown): number | null {
  const hours = normalizeVehicleMinRentalHours(value)
  return hours === null ? null : hours / 24
}
